import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import router from '@/../src/router/index'
import axios from 'axios'

let state = {
  SICCIJ_Catalogos_001Areas: [],
  SICCIJ_Catalogos_004AgendaBloquesFechas: [],
  SICCIJ_Catalogos_004AgendaBloquesHoras: [],
  SICCIJ_Catalogos_012TiposEstatusDeCitas: [],
  SICCIJ_Catalogos_013TiposTramites: [],
  SICCIJ_Catalogos_014TiposEstatusDeTramitesCitas: [],
  SICCIJ_Catalogos_015TiposEstatusDeExpedientes: [],
  SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada: null,
  SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta: null,
}

let getters = {
  Get_SICCIJ_Catalogos_001Area: state => {
      return state.SICCIJ_Catalogos_001Areas;
    },
    Get_SICCIJ_Catalogos_004AgendaBloquesFechas: state => {
        return state.SICCIJ_Catalogos_004AgendaBloquesFechas;
    },
    Get_SICCIJ_Catalogos_004AgendaBloquesHoras: state => {
        return state.SICCIJ_Catalogos_004AgendaBloquesHoras;
    },
  Get_SICCIJ_Catalogos_012TipoEstatusDeCita: state => {
      return state.SICCIJ_Catalogos_012TipoEstatusDeCita;
  },
  Get_SICCIJ_Catalogos_013TipoTramite: state => {
      return state.SICCIJ_Catalogos_013TipoTramite;
  },
  Get_SICCIJ_Catalogos_014TipoEstatusDeTramiteCita: state => {
      return state.SICCIJ_Catalogos_014TipoEstatusDeTramiteCita;
  },
  Get_SICCIJ_Catalogos_015TipoEstatusDeExpediente: state => {
      return state.SICCIJ_Catalogos_015TipoEstatusDeExpediente;
  },
  Get_SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada: state => {
    return state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada;
  },
  Get_SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta: state => {
    return state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta;
  }
}

let mutations = {
  M_SICCIJ_Catalogos_001Area(state, data) {
    state.SICCIJ_Catalogos_001Areas[data.llave] = data.valor;
    },
    M_SICCIJ_Catalogos_004AgendaBloquesFechas(state, data) {
        state.SICCIJ_Catalogos_004AgendaBloquesFechas[data.llave] = data.valor;
    },
    M_SICCIJ_Catalogos_004AgendaBloquesHoras(state, data) {
        state.SICCIJ_Catalogos_004AgendaBloquesHoras[data.llave] = data.valor;
  },
  M_SICCIJ_Catalogos_012TipoEstatusDeCita(state, data) {
    state.SICCIJ_Catalogos_012TiposEstatusDeCitas[data.llave] = data.valor;
  },
  M_SICCIJ_Catalogos_013TipoTramite(state, data) {
    state.SICCIJ_Catalogos_013TiposTramites[data.llave] = data.valor;
  },
  M_SICCIJ_Catalogos_014TipoEstatusDeTramiteCita(state, data) {
    state.SICCIJ_Catalogos_014TiposEstatusDeTramitesCitas[data.llave] = data.valor;
  },
  M_SICCIJ_Catalogos_015TipoEstatusDeExpediente(state, data) {
    state.SICCIJ_Catalogos_015TiposEstatusDeExpedientes[data.llave] = data.valor;
  },
  M_SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada(state, data) {
    state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionada = data;
  },
  M_SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta(state, data) {
    state.SICCIJ_AgendarCita_TemporizadorFechaHoraSeleccionadaCuenta = data;
  }
}

let actions = {
  A_SICCIJ_Catalogo_Establecer001Area: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_001Area', data);
    },
    A_SICCIJ_Catalogo_Establecer004AgendaBloquesFechas: ({ commit }, data) => {
        commit('M_SICCIJ_Catalogos_004AgendaBloquesFechas', data);
    },
    A_SICCIJ_Catalogo_Establecer004AgendaBloquesHoras: ({ commit }, data) => {
        commit('M_SICCIJ_Catalogos_004AgendaBloquesFechas', data);
  },
  A_SICCIJ_Catalogo_Establecer012TipoEstatusDeCita: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_012TipoEstatusDeCita', data);
  },
  A_SICCIJ_Catalogo_Establecer013TipoTramite: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_013TipoTramite', data);
  },
  A_SICCIJ_Catalogo_Establecer014TipoEstatusDeTramiteCita: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_014TipoEstatusDeTramiteCita', data);
  },
  A_SICCIJ_Catalogo_Establecer015TipoEstatusDeExpediente: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_015TipoEstatusDeExpediente', data);
  },
  A_SICCIJ_Catalogo_EstablecerTemporizadorFechaHoraSeleccionada: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_TemporizadorFechaHoraSeleccionada', data);
  },
  A_SICCIJ_Catalogo_EstablecerTemporizadorFechaHoraSeleccionadaCuenta: ({ commit }, data) => {
    commit('M_SICCIJ_Catalogos_TemporizadorFechaHoraSeleccionadaCuenta', data);
  }
}

const SICCIJ = {
  Getters: getters,
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default SICCIJ;



// WEBPACK FOOTER //
// ./src/store/SICCIJ.js